import { render } from "./klaviyo-bis-drawer.vue?vue&type=template&id=5f237616"
import script from "./klaviyo-bis-drawer.vue?vue&type=script&lang=js"
export * from "./klaviyo-bis-drawer.vue?vue&type=script&lang=js"

import "./klaviyo-bis-drawer.vue?vue&type=style&index=0&id=5f237616&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__